import React from "react";
import "./styles.scss";

export default class SelectorItem extends React.Component {
  render() {
    var value = this.props.value;
    var active = this.props.active;

    return (
      <div className={`selectorItem ${active ? "active" : ""}`}>
        <div className="value">{value}</div>

        <div className="additionalData">{this.props.children}</div>
      </div>
    );
  }
}
